// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { LME_OMS_API } from './typings';
const {
  REFRESH_TOKEN_URL,
  USER_URL,
  USER_PROFILE_URL,
  MORELLATO_OMS_LOCATION_URL,
  MORELLATO_OMS_MARKETPLACE_URL,
} = API;

export async function query(): Promise<any> {
  return request(USER_URL);
}

/** 获取当前的用户 GET /api/currentUser */
export async function queryCurrentUser(): Promise<any> {
  return request(`${USER_PROFILE_URL}/info`, {
    method: 'GET',
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<LME_OMS_API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

// refresh token
export async function refreshToken(): Promise<any> {
  return request(REFRESH_TOKEN_URL);
}

export async function queryOMSMarketplacePlatforms() {
  return request(`${MORELLATO_OMS_MARKETPLACE_URL}/platforms`, {
    method: 'GET',
  });
}

export async function queryCountry() {
  return request(`${MORELLATO_OMS_LOCATION_URL}/countries`, {
    method: 'GET',
    useCache: true,
    ttl: 60000,
  });
}
export async function queryCountryStates(country_code: string) {
  return request(`${MORELLATO_OMS_LOCATION_URL}/country/${country_code}/states`, {
    method: 'GET',
  });
}

export async function queryCountryCityList(country_code: string) {
  return request(`${MORELLATO_OMS_LOCATION_URL}/country/${country_code}/cities`, {
    method: 'GET',
  });
}

export async function queryCourierPackageFlatBoxes() {
  return request(`${LME_OMS_COURIER_PACKAGE_URL}/flat-boxes`, {
    method: 'GET',
  });
}

export async function getDeliveryNoteOptions() {
  return request(`${JOR_WMS_DELIVERY_NOTE_URL}/options`, {
    method: 'GET',
  });
}
